import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import VueRouter from 'vue-router'
import router from './routers'
import axiosConfig from './axios';
import config from './config'
import utils from './assets/js/utils.js'
// import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
// import 'vue-directive-image-previewer/dist/assets/style.css'

const Bus = (Vue) => {
  const Bus = new Vue({
    methods: {
      on(event, ...args) {
        this.$on(event, ...args);
      },
      emit(event, callback) {
        this.$emit(event, callback);
      },
      off(event, callback) {
        this.$off(event, callback);
      },
    },
  });
  Vue.prototype.$bus = Bus;
};
Vue.use(Bus)

// Vue.use(VueDirectiveImagePreviewer)
Vue.prototype.utils = utils
Vue.prototype.$config = config
Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(Antd)
new Vue({
  router: router,
  axios: axiosConfig,
  render: h => h(App),
}).$mount('#app')